import React from 'react';
import PropTypes from 'prop-types';
import commonStrings from '../../resources/commonStrings';
import utils from '../utils'; // importing default to allow mocking -> unit testing

import RadioList from './RadioList';

import { levelFilters, ReportLevelItems, whatImDoingFilters } from '../GrowthReports/reportDetails';
import { roleLevels } from '../../resources/roles';
import mutuallyExclusiveFiltersUtils from './mutuallyExclusiveFiltersUtils';

const propTypes = {
  containingTab: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  mutuallyExclusiveFilterState: PropTypes.shape().isRequired,
  roleLevel: PropTypes.string.isRequired,
  onAccordionStateChange: PropTypes.func.isRequired,
  allReportDetails: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  sortingMethod: PropTypes.string.isRequired,
};

function ReportLevelFilter({
  containingTab,
  identifier,
  value,
  mutuallyExclusiveFilterState,
  roleLevel,
  onAccordionStateChange,
  allReportDetails,
  sortingMethod,
}) {
  const radioItems = ReportLevelItems.filter((item) => {
    return (
      item.value !== levelFilters.schoolOrDistrict ||
      (roleLevel === roleLevels.district && item.displayText === commonStrings.reportLevelFilters.schoolOrDistrict) ||
      (roleLevel === roleLevels.school && item.displayText === commonStrings.reportLevelFilters.school)
    );
  });

  const radioListItems = mutuallyExclusiveFiltersUtils.disableFilterItems(
    radioItems,
    mutuallyExclusiveFiltersUtils.getDisabledItemsFromMutuallyExclusiveFilter(mutuallyExclusiveFilterState)
  );

  /**
   * This function is passed to determine if the combination of a filter value an an mutuallyExclusive filter value result in 0 reports
   */
  const isFilterCombinationDisabled = (whatImDoingFilterValue, levelFilterValue) => {
    return (
      utils.filterGrowthReports(allReportDetails, levelFilterValue, whatImDoingFilterValue, sortingMethod).length === 0
    );
  };

  return (
    <RadioList
      containingTab={containingTab}
      identifier={identifier}
      items={radioListItems}
      onAccordionStateChange={onAccordionStateChange}
      value={value}
      onItemSelect={mutuallyExclusiveFiltersUtils.getItemValueAndMutuallyExclusiveFilterHandler(
        isFilterCombinationDisabled
      )}
    />
  );
}

ReportLevelFilter.propTypes = propTypes;

export default ReportLevelFilter;
